/* global axios */

import ApiClient from './ApiClient';

class Invoice extends ApiClient {
  constructor() {
    super('enterprise_infos', { accountScoped: true });
  }

  // 获取企业信息列表
  getEnterpriseInfos() {
    return axios.get(this.url);
  }

  // 创建企业信息
  createEnterpriseInfo(data) {
    return axios.post(this.url, {
      enterprise_info: data,
    });
  }

  // 更新企业信息
  updateEnterpriseInfo(infoId, data) {
    return axios.patch(`${this.url}/${infoId}`, {
      enterprise_info: data,
    });
  }

  // 删除企业信息
  deleteEnterpriseInfo(infoId) {
    return axios.delete(`${this.url}/${infoId}`);
  }

  // 申请发票
  applyInvoice(orderNo, data) {
    return axios.post(
      `${this.baseUrl()}/seat_orders/${orderNo}/apply_invoice`,
      data
    );
  }

  // 获取发票状态
  getInvoiceStatus(orderNo) {
    return axios.get(`${this.baseUrl()}/seat_orders/${orderNo}/invoice_status`);
  }
}

export default new Invoice();
